import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { WorkTeamsCreate } from './WorkTeamsCreate/WorkTeamsCreate';
import { WorkTeamsEdit } from './WorkTeamsEdit/WorkTeamsEdit';
import { WorkTeamsList } from './WorkTeamsList/WorkTeamsList';
import { WorkTeamsShow } from './WorkTeamsShow/WorkTeamsShow';

export const workTeamsResource: ResourceProps = {
  name: Resources.WorkTeams,
  list: WorkTeamsList,
  create: WorkTeamsCreate,
  edit: WorkTeamsEdit,
  show: WorkTeamsShow,
};
